import { GapManagementDashboardService } from "@app/projects/network-assessment/gap-management-dashboard/gapManagementDashboardService"
import { GmdWidgetProps } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gmdWidgetProps"
import { MetricsDonut } from "@app/shared/metrics/MetricsDonut"
import { QESWidget, QESWidgetHeader, QESWidgetTitle, QESWidgetContent } from "@app/shared/widget"
import Roles from "@app/user/roles"
import { UserContext } from "@app/user/UserContext"
import { useQuery } from "@tanstack/react-query"
import { FC, useContext, useMemo, useRef } from "react"

export const FillabilityBreakdownWidget: FC<GmdWidgetProps> = ({ loadingIcon, errorBanner }) => {
  const user = useContext(UserContext);
  const gapManagementDashboardService = useRef(new GapManagementDashboardService()).current;

  const { data: fillabilityBreakdownData, isError, isLoading } = useQuery({
    enabled: true,
    queryFn: ({ signal }) => gapManagementDashboardService.getFillabilityBreakdownData(user.roles.includes(Roles.ENTERPRISE_COMPLIANCE_DASHBOARD_USER), signal),
    queryKey: ["gmd-fillability-breakdown"],
  });

  const totalGaps = useMemo(() => {
      return fillabilityBreakdownData?.segments.reduce((total, value) => total += value.numberValue, 0) || 0;
    }, [fillabilityBreakdownData]);

  return (
    <QESWidget className="gap-management-dashboard__widget gap-management-dashboard__donut-chart-widget">
      <QESWidgetHeader>
        <QESWidgetTitle>Fillability Breakdown</QESWidgetTitle>
      </QESWidgetHeader>
      <QESWidgetContent>
        {isLoading ? loadingIcon :
          isError ? errorBanner : (
            <MetricsDonut
              {...fillabilityBreakdownData}
              description={`A donut chart. Its segments represent ${fillabilityBreakdownData?.segments.map((segment) => `${segment.numberValue} gaps ${segment.label}, `)}. The total is ${totalGaps}.`}
            />
          )}
      </QESWidgetContent>
    </QESWidget>
  )
}